module.exports = __webpack_public_path__ + "img/o-festival-title.60721e5a.png";